// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AJz2r","fullView":"styles_fullView__2PN3H"};